import React from 'react';
import './Colors.css';

export type ColorVariant = 
    | 'primary-green'
    | 'light-green'
    | 'dark-green'
    | 'white'
    | 'black'
    | 'light-gray'
    | 'dark-gray'
    | 'gray'
    | 'warning-yellow'
    | 'warning-red'
    | 'pastelle-yellow'
    | 'pastelle-red'
    | 'pastelle-gray'
    | 'pastelle-blue';

interface ColorsProps {
    variant: ColorVariant;
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    as?: React.ElementType;
}

// Color utility function to get CSS variable
export const getColor = (variant: ColorVariant): string => {
    return `var(--color-${variant.replace('-', '-')})`;
};

// Color utility function to get CSS variable with opacity
export const getColorWithOpacity = (variant: ColorVariant, opacity: number): string => {
    const color = getColor(variant);
    return `${color}${Math.round(opacity * 255).toString(16).padStart(2, '0')}`;
};

const Colors: React.FC<ColorsProps> = ({
    variant,
    children,
    className,
    style,
    as: Component = 'div'
}) => {
    const colorClass = `color-${variant.replace('-', '-')}`;
    const combinedClassName = `color ${colorClass} ${className || ''}`.trim();

    return (
        <Component
            className={combinedClassName}
            style={{
                color: getColor(variant),
                ...style
            }}
        >
            {children}
        </Component>
    );
};

export default Colors;
